import ActivePackagesReducer from "./redux/activePackagesReducer";
import ActivePackagesSaga from "./redux/activePackagesSaga";
import { ActivePackagesModule } from "./activePackagesModule";

export default {
  Component: ActivePackagesModule,
  moduleName: "activePackages",
  saga: ActivePackagesSaga(),
  reducer: ActivePackagesReducer
};
